import React, { useContext, useState } from "react";
import { StyleSheet, Image, TouchableOpacity, ScrollView, Alert, Text } from "react-native";
import * as Yup from "yup";
import {
  ErrorMessage,
  Form,
  FormField,
  SubmitButton,
} from "../components/forms";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ListItemAccount } from "../components/lists";
import colors from "../config/colors";
import Icon from "../components/Icon";
import Screen from "../components/Screen";
//import useAuth from "../auth/useAuth";
import configurationPost from "../config/configurationPost";
import * as ImagePicker from "expo-image-picker"
import connectionConfig from "../config/settings";
import dateNow from "../utility/dateNow";
import UploadScreen from "./UploadScreen";
//import settingStorage from "../config/settingStorage";
//import AsyncStorage from "@react-native-async-storage/async-storage";
import routes from "../navigation/routes";
import AuthContext from "../auth/context";
import storage from "../auth/storage";

var date = dateNow()

const validationSchema = Yup.object().shape({
  userName: Yup.string().required().label("userName"),
  alias: Yup.string().required().max(150).label("Alias"),
  userDescription: Yup.string().max(250).label('userDescription')
});

function AccountScreen({ navigation }) {

  const [progress, setProgress] = useState(0);
  const [imageUri, setimageUri] = useState('');
  const [uploadVisible, setUploadVisible] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const { user, setUser } =useContext(AuthContext);

  var profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
  var userId = JSON.parse(user).userId
  var userPhoto = JSON.parse(user).userPhoto
  //const auth = useAuth();

  var access_fixo = []

  const handleSubmit = async ({ userName, alias, userDescription }) => {
    //debugger
    //resetForm()
    setProgress(0);
    if (imageUri != '') {
      var post_values = {
        userName: userName,
        userPhoto: date.replace(/ /g, '_').replace(/\//g, '-') + '_photo.jpg',
        alias: alias,
        userDescription: userDescription,
        userId: userId,

      }
    } else {
      var post_values = {
        userName: userName,
        userPhoto: userPhoto,
        alias: alias,
        userDescription: userDescription,
        userId: userId,

      }
    }

    var configurationPost = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, *.*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post_values)
    }
    await fetch(connectionConfig.apiUrl + '/fixoUsers/updateUser/', configurationPost)
      .then(response => response.json())
      .then(response => {
        console.log('update regresa', response)
        setProgress(50);
        setUploadVisible(true)
        if (imageUri != '') {
          savePhoto()
        }
        selectUser()
      })
      .catch(err => {
        console.log('update fixo failed :( review internet service', err)
      })
  };
  //--------------------------------------------
  //rutina que guarda fotos de perfil de usuario
  //--------------------------------------------
  const savePhoto = async () => {
    let uri = imageUri
    let index = uri.lastIndexOf('/')
    let fileName = imageUri.substring(index + 1)
    //debugger
    try {
      const nameDatePhoto = userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_photo.jpg'
      const formData = new FormData()
      formData.append('photo', {
        uri: imageUri,
        type: 'image/jpg',
        name: nameDatePhoto
      })
      const configurationPost = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
        body: formData
      }
      // post Para guardar imagen de perfil
      fetch(connectionConfig.apiUrl + '/native_upload_single', configurationPost)
        .then(response => response.json())
        .then(response => {
          //debugger
          if (response.data === 'descarga-> error') {
            Alert.alert("Notification", ": maintennance server -> please try later")
          }
        })
        .catch((err) => {
          Alert.alert("Notification", ": maintennance server -> please try later")
        })
    } catch (error) {
      Alert.alert("Notification", ": maintennance server -> please try later")
    }
  }
  //--------------------------------
  //Busca el usuario una vez editado
  //--------------------------------
  const selectUser = async () => {
    var post_values = {
      insertId: userId,
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/selectUser', configurationPost)
      .then(response => response.json())
      .then(response => {
        console.log('selectUser regresa', response)
        //debugger
        access_fixo = response.data
        var settingStorage = {
          json: {
              country: '',
              userId: '',
              userName: '',
              email: '',
              userPhoto: '',
              userPassword: '',
              createDate: '',
              countryId: '',
              country: '',
              alias: ''
          },
          KEY: 'fixo.charly'
        }
               
        settingStorage.json.country = access_fixo[0].country
        settingStorage.json.userId = access_fixo[0].userId
        settingStorage.json.userName = access_fixo[0].userName
        settingStorage.json.userPhoto = access_fixo[0].userPhoto
        settingStorage.json.email = access_fixo[0].email
        settingStorage.json.createDate = access_fixo[0].createDate       

    var userInformation = JSON.stringify(settingStorage.json)  
      //    //debugger

        storage.storeToken(userInformation);
         setUser(userInformation)
      
        setProgress(100);
        navigation.navigate(routes.USER_FIXO)
      })
      .catch(err => {
        console.log(':( review internet service /selectUser/', err)
      })
  }

  const selectImage = async () => {
    try {
      const result = await ImagePicker.launchImageLibraryAsync()
      if (!result.cancelled)
        setimageUri(result.uri)
    } catch (error) {
      console.log("error al leer imagen", error)
    }
  }
  return (
    <ScrollView>
      <Screen style={styles.container}>

        <UploadScreen
          onDone={() => setUploadVisible(false)}
          progress={progress}
          visible={uploadVisible}
        />
        <TouchableOpacity onPress={selectImage}>
          {imageUri != '' ?
            <Image style={styles.image} source={{ uri: imageUri }} />
            :
            <Image style={styles.image} source={{ uri: profileUri + userId + '_' + userPhoto }} />
          }
          <MaterialCommunityIcons
            style={styles.touchable}
            name="pencil-circle"
            size={40}
            color="blue"
          />
        </TouchableOpacity>
        <Form
          style={styles.containerF}
          initialValues={{ userName: JSON.parse(user).userName, alias: "Charliño", userDescription: "Salavador del mundo" }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <ErrorMessage
            error="Invalid email and/or password."
            visible={loginFailed}
          />
          <Text style={styles.txtTitle}>Nombre de usuario</Text>
          <FormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="account-edit"
            name="userName"
            placeholder="User name"
            maxLength={100}
          />
          <Text style={styles.txtTitle}>Alias de usuario</Text>
          <FormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="account-edit"
            name="alias"
            placeholder="Alias"
            maxLength={50}
          />
          <Text style={styles.txtTitle}>Yo soy: </Text>
          <FormField
            autoCapitalize="none"
            autoCorrect={false}
            icon="book-open-outline"
            name="userDescription"
            placeholder="Description"
            maxLength={250}
          />
          <SubmitButton txtStyle={styles.txtSubmit} btnStyle={styles.btnSubmit} color={'pistache'} title="Guardar cambios" />
        </Form>
        <ListItemAccount
          titleRol="Cerrar sesión"
          IconComponent={<Icon name="logout" backgroundColor="#ffe66d" />}
          onPress={() => {
            storage.removeToken()
            setUser('')
          }}
        />    
      </Screen>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  screen: {
    //backgroundColor: colors.light,
  },
  container: {
    paddingLeft: '2%',
    paddingRight: '2%'
  },
  container: {
    // marginLeft: 2,
    // marginRight: 2,
    paddingLeft: '3%',
    paddingRight: '3%'
  },
  image: {
    width: 180,
    height: 180,
    flexDirection: "row",
    alignSelf: "center",
    marginTop: 20,
    marginBottom: 20,
    borderRadius: 5,
  },
  touchable: {
    position: "absolute",
    //alignSelf: "center",
    marginLeft: "57%",//20,
    marginTop: "30%"//110
    // alignItems:"baseline"

  },
  txtTitle: {
    marginLeft: "5%",//20,

  },
  txtSubmit: {
    marginLeft: "5%",//20,
    color: colors.green,
    fontSize: 18,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  btnSubmit: {
    marginLeft: "23%",//20,
    width: '55%',
    height: '7%',
    borderRadius: 10,
    paddingTop: 13
  },
});

export default AccountScreen;
